import { Avatar, Button, Card, Form, Input, NavBar, Toast } from "antd-mobile";
import { LockOutline, StopOutline, UserOutline } from "antd-mobile-icons";
import { useEffect, useState } from "react";
import { changePassword, loadUserInfo } from "../componet/service";
import '../styles/MyPage.css';
import { useNavigate } from "react-router-dom";

const MyPage = () => {
  const [form] = Form.useForm();
  const [toChange, setToChange] = useState(false);
  const [user, setUser] = useState({});
  const navigate = useNavigate();

  // ... 现有代码保持不变 ...
  const loadUser = async () => {
    const res = await loadUserInfo();
    if (res.code === 0) {
      setUser(res.data);
    } else {
      Toast.show({
        icon: 'fail',
        content: res.msg
      });
    }
  }

  useEffect(() => {
    loadUser();
  }, [])

  const onFinish = async () => {
    // ... 现有代码保持不变 ...
    const res = await changePassword(form.getFieldValue("password"), form.getFieldValue("newPassword"), form.getFieldValue("newPassword2"));
    if (res.code === 0) {
      Toast.show({
        icon: 'success',
        content: '修改成功'
      });
      setToChange(false);
    } else {
      Toast.show({
        icon: 'fail',
        content: res.msg
      });
    }
  }

  return (
    <div className="my-page-container">
      <NavBar className="my-page-navbar" back={null} onBack={() => {
        console.dir("back")
        navigate("/")
      }}>个人中心</NavBar>

      <div className="my-page-content">
        <Card className="user-info-card">
          <div className="user-info-content">
            <Avatar src={user.avatarUrl} className="user-avatar" />
            <div className="user-details">
              <div className="user-name">{user.name || '未登录'}</div>
              <div className="user-department">{user.departmentName || '暂无部门'}</div>
            </div>
          </div>
        </Card>

        {!toChange && (
          <div className="action-buttons">
            <Button
              block
              className="password-button"
              onClick={() => {
                form?.setFieldsValue({
                  password: null,
                  newPassword: null,
                  newPassword2: null
                })
                setToChange(true);
              }}
            >
              <UserOutline className="button-icon" />
              修改密码
            </Button>

            <Button
              block
              className="logout-button"
              onClick={() => {
                localStorage.removeItem("token");
                window.location.reload();
              }}
            >
              <StopOutline className="button-icon" />
              退出登录
            </Button>
          </div>
        )}

        {toChange && (
          <Card className="password-form-card">
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              className="password-form"
            >
              <Form.Header><h2 className="form-title">修改密码</h2></Form.Header>

              <Form.Item
                name="password"
                label="原密码"
                rules={[{ required: true, message: '请输入原密码' }]}
              >
                <Input
                  type="password"
                  placeholder="请输入原密码"
                  clearable
                  className="password-input"
                  prefix={<UserOutline />}
                />
              </Form.Item>

              <Form.Item
                name="newPassword"
                label="新密码"
                rules={[{ required: true, message: '请输入新密码' },
                { min: 6, message: '密码至少6位' }, { max: 16, message: '密码至多16位' }]}
              >
                <Input
                  type="password"
                  placeholder="请输入新密码"
                  clearable
                  className="password-input"
                  prefix={<LockOutline />}
                />
              </Form.Item>

              <Form.Item
                name="newPassword2"
                label="确认密码"
                rules={[{ required: true, message: '请输入确认密码' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('两次输入的密码不一致'));
                  },
                })
                ]}
              >
                <Input
                  type="password"
                  placeholder="请输入确认密码"
                  clearable
                  className="password-input"
                  prefix={<LockOutline />}
                />
              </Form.Item>

              <Form.Item>
                <div className="form-buttons">
                  <Button
                    className="cancel-button"
                    onClick={() => {
                      setToChange(false);
                    }}
                  >
                    取消修改
                  </Button>

                  <Button
                    type="submit"
                    className="submit-button"
                  >
                    立即修改
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </Card>
        )}
      </div>
    </div>
  );
};

export default MyPage;